import { AudiencePageTemplate } from '@/components/AudiencePageTemplate'
import { getAudienceSegment } from '@/data/whoWeServe'

export default function ChoralFestivalsPage() {
  return <AudiencePageTemplate segment={getAudienceSegment('choral-festivals')} />
}
